import SignIn from '../SignIn/SignIn'

export const SignInPage = () => <SignIn />
